


import { Routes, RouterModule } from '@angular/router';
import { WorkflowDefineFormComponent } from './workflowdefine-form/workflowdefine-form.component';
import { WorkflowDefineComponent } from './workflowdefine.component';

const routes: Routes = [
    {
        path: '',
        component: WorkflowDefineComponent
    },
    {
        path: 'detail',
        component: WorkflowDefineFormComponent
    },
    {
        path: 'detail/:id',
        component: WorkflowDefineFormComponent
    }
];

export const WorkflowDefineRoutes = RouterModule.forChild(routes);
